import React from "react";
import { Link, useLocation } from "react-router-dom";

// Links to a section of the homepage: a plain anchor on the homepage,
// a router link back to it from any other page.
const SectionLink = ({ to, children, ...props }) => {
  const { pathname } = useLocation();
  return pathname === "/" ? (
    <a href={`#${to}`} {...props}>{children}</a>
  ) : (
    <Link to={`/#${to}`} {...props}>{children}</Link>
  );
};

export default SectionLink;
